import * as React from "react";

export interface Props {
  pageTitle: string;
}

const Breadcrumbs = ({ pageTitle }: Props) => {
  return (
    <div id="breadcrumbs">
      <a href="https://www.fdic.gov/">Home</a> &gt;
      <a href="https://www.fdic.gov/resources/">Resources</a> &gt;
      <a href="https://www.fdic.gov/resources/data-tools/">Data Tools</a>
      &gt; {pageTitle}
    </div>
  );
};

export default Breadcrumbs;
